import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import { faCog } from '@icons/solid/faCog';

import { useFlyout, type FlyoutOperations } from './flyout';
import type { DataItem } from './table';

/**
 * `CellOperations` component properties.
 */
export interface Props<T extends DataItem = DataItem> {
  /** The table row item subject of the flyout. */
  item: T;
  /** The list of operations to enumerate within the flyout. */
  operations: FlyoutOperations<T>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CellOperations',
  props: {
    item: null,
    operations: null
  },
  setup(__props: any) {

const props = __props as {
  /** The table row item subject of the flyout. */
  item: T;
  /** The list of operations to enumerate within the flyout. */
  operations: FlyoutOperations<T>;
};



const el = ref<HTMLDivElement | null>(null);

const flyout = useFlyout(props.operations);

/**
 * Toggle the flyout "on" or "off".
 */
function toggleFlyout() {
  if (flyout.isOpen) return flyout.close();

  if (!el.value) {
    // eslint-disable-next-line no-console
    return console.warn(
      '[CellOperations.toggleFlyout] component element has not been rendered.',
    );
  }

  let { x, y } = el.value.getBoundingClientRect();

  x += 0.5 * el.value.offsetWidth;
  y += 0.5 * el.value.offsetHeight;

  flyout.open(props.item, x, y);
}

return { __sfc: true,props, el, flyout, toggleFlyout, faCog }
}

})